import { render, staticRenderFns } from "./RoomStatus.vue?vue&type=template&id=67296be0"
import script from "./RoomStatus.vue?vue&type=script&lang=js"
export * from "./RoomStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports